import { ErrorBoundary } from '@sentry/react';
import { lazy, ReactElement, Suspense } from 'react';

import { isLocalEnvironment, isTestMode } from '../../utils/environment.utils';

// Dev-only visual feedback widget: bottom-right toolbar that lets a developer/PM annotate
// any element on the page and copy a structured markdown blob for AI coding agents to act on.
// Gated to local/test envs only — the vendor intends it strictly for local development, so it is
// not shipped to deployed non-prod envs (staging, etc.) the way Apollo devtools are.
// Lazy-loaded so the `agentation` dev dependency is code-split out of the production bundle,
// and wrapped in an ErrorBoundary so a widget crash can never take down the host app.
const Agentation = lazy(async () => ({ default: (await import('agentation')).Agentation }));

export const AgentationWidget = (): ReactElement | null => {
  if (!isLocalEnvironment() && !isTestMode()) {
    return null;
  }
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={null}>
        <Agentation />
      </Suspense>
    </ErrorBoundary>
  );
};
